import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function UploadPhotos({
  stroke = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '2',
  ...props
}) {
  return (
    <IconBase viewBox='8 0 32 32' {...props}>
      <Path
        d='M36 4.50325H29'
        stroke={stroke}
        strokeWidth={strokeWidth}
        stroke-linecap='round'
        stroke-linejoin='round'
        fill={fill}
      />
      <Path
        d='M32.5032 1V8'
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M28.9983 24.8423L25.1823 21.0263C24.8347 20.6787
         24.272 20.6787 23.9254 21.0263L20.1094 24.8423'
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.3333 29.2813H15.6667C14.1938
          29.2813 13 28.0875 13 26.6146V15.9479C13
           14.475 14.1938 13.2812 15.6667 13.2812H26.3333C27.8062
            13.2812 29 14.475 29 15.9479V26.6146C29
            28.0875 27.8062 29.2813 26.3333 29.2813Z'
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M24.5575 29.2763L18.9638 23.6825C18.6162
        23.335 18.0535 23.335 17.7069 23.6825L13.3984 27.991'
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M18.5708 18.3728C18.7009 18.503 18.7009
        18.714 18.5708 18.8442C18.4406 18.9744
        18.2295 18.9744 18.0994 18.8442C17.9692
        18.714 17.9692 18.503 18.0994 18.3728C18.2295
        18.2426 18.4406 18.2426 18.5708 18.3728'
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}
UploadPhotos.propTypes = {
  stroke: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default UploadPhotos
